import { render, staticRenderFns } from "./AccountDetailsCommonInfoReadOnly.vue?vue&type=template&id=52dd39d6&scoped=true"
import script from "./AccountDetailsCommonInfoReadOnly.vue?vue&type=script&lang=js"
export * from "./AccountDetailsCommonInfoReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd39d6",
  null
  
)

export default component.exports